import React from "react";
import Image from "components/image";

const FooterCopyright = ({ data }) => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="w-full py-4 lg:py-5 px-0 float-left text-sm font-prompt text-gray-601">
            <div
                className="container mx-auto flex justify-between items-center flex-col lg:flex-row"
            >
                <p className="float-left m-0 w-auto text-center pb-1 md:pb-0">
                    {`Copyright © ${currentYear} Seal Skin Covers - All Rights Reserved.`}
                </p>
                <ul className="w-auto float-right flex items-center;">
                    {data?.map((icon) => (
                        <li
                            key={icon?._key}
                            className="inline-block mx-1.5 my-0 list-none"
                        >
                            <Image image={icon} width={32} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default FooterCopyright;
